import { getCurrentInstance, onBeforeUnmount, readonly, reactive } from "vue";

// Datos de pantalla que las páginas comparten con el asistente IA y que el widget no puede
// deducir de la ruta (la página, los IDs y la pestaña los calcula él solo).
// Solo etiquetas de la interfaz: nunca datos de clientes.
const CAMPI = ["tipoProdotto"];
const MAX_LUNGHEZZA = 80;

const stato = reactive({});
// Qué página puso cada campo, para que al salir solo borre lo suyo
const proprietari = {};
let ultimoId = 0;

/** Estado actual, solo lectura (lo usa AppLayout para el getContext del asistente). */
export function useAiContext() {
  return readonly(stato);
}

function pulisci(valore) {
  if (typeof valore !== "string") return undefined;
  const testo = valore.trim().slice(0, MAX_LUNGHEZZA);
  return testo || undefined;
}

/**
 * Para usar en una página: publica sus datos y los borra al salir.
 *
 *   const aiContext = usePaginaAi();
 *   aiContext.imposta({ tipoProdotto: "Cessione" });
 */
export function usePaginaAi() {
  const id = ++ultimoId;

  function imposta(valori) {
    Object.entries(valori).forEach(([campo, valore]) => {
      if (!CAMPI.includes(campo)) return;
      stato[campo] = pulisci(valore);
      proprietari[campo] = id;
    });
  }

  if (getCurrentInstance()) {
    onBeforeUnmount(() => {
      CAMPI.forEach((campo) => {
        if (proprietari[campo] === id) {
          delete stato[campo];
          delete proprietari[campo];
        }
      });
    });
  }

  return { imposta };
}
